/**
 * @fileoverview Module for `src/lib/functions/identity.js`.
 */

/**
 * Returns its argument unchanged, useful as a default no-transform callback.
 *
 * @param {*} x - Input value.
 * @returns {*} Same input value.
 */
function identity(x) {
  return x;
}

export default identity;
